import type { shell as en } from '@/i18n/locales/en/shell';
import type { Translation } from '@/i18n/types';

export const shell: Translation<typeof en> = {
  notFound: {
    title: 'Pagina non trovata',
    body: 'Questo indirizzo non esiste.',
    backLink: 'Torna alla panoramica',
  },
  configWarning: {
    body: '<0>Configurazione incompleta.</0> Manca {{missing}}. Impostalo in <1>.env.local</1> per lo sviluppo locale (vedi <2>.env.example</2>), oppure nell’ambiente del container per un deployment.',
  },
  skipToContent: 'Vai al contenuto',
  brandName: 'NOLATR',
  mainNav: 'Principale',
  sectionNav: 'Sezione',
  accountNav: 'Account',
  openMainMenu: 'Apri menu',
  closeMainMenu: 'Chiudi menu',
  activeCompany: 'Azienda attiva',
  profileStub: {
    title: 'Profilo',
    lead: 'La tua pagina profilo è in arrivo — per ora questo è un segnaposto affinché l’app abbia dove mandarti.',
  },
  manageStub: {
    title: 'Gestisci',
    lead: 'Scegli una sezione dal menu.',
  },
};
